import { render, staticRenderFns } from "./DeveloperPage.vue?vue&type=template&id=437657e2&scoped=true&"
import script from "./DeveloperPage.vue?vue&type=script&lang=js&"
export * from "./DeveloperPage.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperPage.vue?vue&type=style&index=0&id=437657e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437657e2",
  null
  
)

export default component.exports